import styles from './styles';

import { UserPermission } from '@cobliteam/common-types';
import {
  GeofenceFormat,
  type PlainGeofence,
} from '@cobliteam/common-types/src/geofenceV3';

import useMonitoringStore from '@cobliteam/monitoring/src/store/useMonitoringStore';

import { DomainTypes } from '@cobliteam/store';

import { Button } from '@cobliteam/ui/components';

import EditRoundedIcon from '@mui/icons-material/EditRounded';

import withPermission from '../../../../PermissionsGate/PermissionsGate';

interface GeofencePopupFooterProps {
  geofence?: PlainGeofence;
}

const formatName = {
  [GeofenceFormat.CIRCLE]: 'círculo',
  [GeofenceFormat.DRAWING]: 'desenho',
  [GeofenceFormat.RECTANGLE]: 'retângulo',
  default: 'círculo',
};

const PopupFooter = ({ geofence }: GeofencePopupFooterProps) => {
  const setGeofenceToEdit = useMonitoringStore(
    (state) => state.setGeofenceToEdit
  );
  const setSelectedTab = useMonitoringStore((state) => state.setSelectedTab);

  const handleEditGeofence = () => {
    setGeofenceToEdit({ id: geofence?.id });
    setSelectedTab(DomainTypes.GEOFENCE_FORM);
  };

  return (
    <div className={styles.popupFooter}>
      <Button
        variant='text'
        color='primary'
        size='condensed'
        startIcon={<EditRoundedIcon />}
        onClick={handleEditGeofence}
        data-cy='geofence-popupfooter'
      >
        {`Editar ${formatName[geofence?.format || 'default']}`}
      </Button>
    </div>
  );
};

export default withPermission(
  UserPermission.CREATE_UPDATE_DELETE_PLACES_OF_INTEREST,
  PopupFooter
);
